export default "__VITE_ASSET__a5ed39bf__"